import {createAccordians} from "./node-accordion";

$(document).ready(function() {

    document.body.addEventListener("displayObjectProperties", () => createAccordians());
    

    $('button.icon-button').click(function(){
        window.app.treeDesigner.clearSelection();
        resetOjectProps();
        adjustMarginsForToolbar();
    });

    $('div.application-toolbar').click(function(){
        setType();
        adjustMarginsForToolbar();
    });

    $('.application-tabmenu-group button').click(function(){
        resetOjectProps();
    })

});

function resetOjectProps(){
    $('#object-properties').removeClass('toolbar-open');
    $('div.application-toolbar.js-toolbar-container').removeClass('open');
    $('.application-toolbar-toggle').removeClass('open');
}

function applyHooks(){
    let body = document.body;
    let hasSelectedNodes = !!window.app.treeDesigner.getSelectedNodes().length;

    $(body).toggleClass('decision-node-selected', hasSelectedNodes);

    if(hasSelectedNodes && !$(body).hasClass('margin-added')){
        // applyRightMargin(50);
    }

    if(!hasSelectedNodes && $(body).hasClass('margin-added')){
        // applyRightMargin(0);
    }

    // $('#object-properties').toggleClass('dragging',!!$('g.dragging').length);

    $('tspan, text').each((i,el)=>{
        if($(el)[0].childNodes.length){
            $(el).css('display',(hideFilter.indexOf($(el)[0].childNodes[0].data) !== -1 ? 'none':''));
        }
    });
    
}

let hideFilter = ['100%','0%'];

// function applyRightMargin(margin){
//     let m = {};
//     let mVal = (margin > 0 ? margin : 50);
//     m.right = parseInt(mVal);
//     window.app.treeDesigner.setMargin(m);
//     $(document.body).toggleClass('margin-added',(parseInt(margin)>0));
// }

function setType(){
    let buttonList = $('ul.application-toolbar-button-group').first();
    let types = ['manual','tree','cluster'];
    let index = types.indexOf(window.app.treeDesigner.layout.config.type);
    if(index !== -1){
        buttonList.children().each((i,e)=>{
            $(e).toggleClass('selected',(i===index));
        });
    }
}

function adjustMarginsForToolbar(){
    $(document.body).toggleClass('application-toolbar-open',$('div.application-toolbar').first().hasClass('open'));
}

var observer = new MutationObserver(function(mutations) {
    if(window.app && mutations.length){
        setTimeout(applyHooks,10);
    }
});

observer.observe(document, {
    subtree: true,
    attributes: true,
});


// WEBPACK FOOTER //
// ./scripts/components/custom-hooks.js